export type RefinementList = Record<string, string[]>;

const NON_FACET_KEYS = new Set([
  'q',
  'urlParts',
  'page',
  'sort-by',
  'priceFrom',
  'priceTo',
]);

const baseKey = (key: string) => key.split('.')[0];

function getFacetValue(val: string) {
  const parts = val.split('|').map((p) => p.trim());
  return (parts[1] || parts[0]).toLowerCase();
}
export function getOrderedAppliedFilters(
  refinementList: RefinementList,
  search: string,
): Array<[string, string[]]> {
  const entries: Array<[string, string[]]> = [];
  if (!search) return Object.entries(refinementList);

  const params = new URLSearchParams(search);
  const usedAttributes = new Set<string>();

  // First pass: collect URL params in order and map to refinements
  params.forEach((_value, key) => {
    if (NON_FACET_KEYS.has(key)) return;

    const matchedAttr = Object.keys(refinementList).find(
      (attr) => baseKey(attr) === key,
    );
    if (!matchedAttr || usedAttributes.has(matchedAttr)) return;

    const urlVals = params.getAll(key);
    const appliedVals = (refinementList[matchedAttr] || []).filter((v) => {
      const valId = getFacetValue(v);
      return urlVals.some((val) => {
        return getFacetValue(val) === valId;
      });
    });

    if (appliedVals.length > 0) {
      // Order the values according to URL order
      const orderedVals = appliedVals.sort((a, b) => {
        const aIndex = urlVals.indexOf(String(a));
        const bIndex = urlVals.indexOf(String(b));
        return aIndex - bIndex;
      });

      entries.push([matchedAttr, orderedVals]);
      usedAttributes.add(matchedAttr);
    }
  });

  // Second pass: append remaining refinements that weren't in URL
  Object.entries(refinementList).forEach(([attr, values]) => {
    if (!usedAttributes.has(attr) && (values?.length ?? 0) > 0) {
      entries.push([attr, values]);
    }
  });

  return entries;
}
